// extracted by mini-css-extract-plugin
export default {"modal":"Alert_modal__OXLaB","text":"Alert_text__gcjJa","closable":"Alert_closable__9IBGZ"};